import moment from "moment";
import CommonService from "./common.service";
import cwLogo from "../assets/media/images/long2.png";

interface IHighChartsOptions {
  series: any;
  rangeSelector?: any;
  showRangeSelector?: boolean;
  chart?: any;
  plotOptions?: any;
  title?: any;
  subtitle?: any;
  legend?: any;
  xAxis?: any;
  yAxis?: any;
  tooltip?: any;
}

export default class HighChartsService {
  static baseSettings(options?: IHighChartsOptions) {
    return {
      chart: {
        plotBackgroundImage: cwLogo,
        ...options?.chart,
      },

      plotOptions: {
        ...options?.plotOptions,
      },

      title: {
        text: "",
        ...options?.title,
      },

      subtitle: {
        text: "",
        ...options?.subtitle,
      },

      xAxis: options?.xAxis ? {
        type: "datetime",
        crosshair: true,
        labels: {
          formatter: function () {
            const th: any = this;
            return moment.unix(th?.value / 1000).format("MM/DD/YYYY");
          },
        },
        ...options?.xAxis,
      } : {},

      yAxis: options?.yAxis,

      legend: options?.legend ? {
        enabled: true,
        ...options?.legend,
      } : {},

      tooltip: options?.tooltip ? {
        shared: true,
        formatter() {
          const th: any = this;

          let s: any = `<b>Value</b> <br /> ${moment
            .unix(th?.x / 1000)
            .format("MM/DD/YYYY")}`;

          th?.points?.forEach((point: any) => {
            s += `<br/>${point?.series?.name}: ${CommonService.toLocalNum(
              point?.y
            )}`;
          });
          return s;
        },
        ...options?.tooltip,
      } : {},

      rangeSelector: !options?.showRangeSelector
        ? {
          enabled: true,
          buttons: [
            {
              type: "all",
            },
          ],
          selected: 0,
          inputEnabled: false,
          rangeSelectorZoom: "",
          buttonTheme: {
            states: {
              hover: {
                fill: "#fff",
                stroke: "#fff",
                style: {
                  color: "#fff",
                },
              },
              select: {
                fill: "#fff",
                stroke: "#fff",
                style: {
                  color: "#fff",
                },
              },
            },
          },
        }
        : { ...options?.rangeSelector },

      series: options?.series,
    };
  }
}
